import React, { useState } from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../lib/firebase/config';
import BSAQuery from '../components/BSAQuery/BSAQuery';
import '../components/BSAQuery/BSAQuery.css';
import { useAuth } from '../contexts/AuthContext';
import { BrandedLoader } from '@orrekie/ui';

const tabs = [
  { label: 'BSA Query', key: 'bsa' },
  { label: 'U Value Tool', key: 'uvalue' },
  { label: 'Building Regulations', key: 'regulations' },
];

export default function Dashboard() {
  const [activeTab, setActiveTab] = useState('bsa');
  const authContext = useAuth();
  const { currentUser, loading } = authContext || {};

  if (loading) {
    return <BrandedLoader message="Loading your dashboard, please wait…" />;
  }

  if (!currentUser) {
    window.location.href = '/login';
    return null;
  }

  const handleLogout = async () => {
    await signOut(auth);
    window.location.href = '/login';
  };

  return (
    <div style={{ fontFamily: 'system-ui, Avenir, Helvetica, Arial, sans-serif', background: '#fff', minHeight: '100vh' }}>
      {/* Navigation Bar */}
      <nav style={{ background: '#0a0e3f', color: '#fff', padding: '0.5rem 2rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ fontWeight: 'bold', fontSize: '2rem', color: '#ff4713', fontFamily: 'monospace', cursor: 'pointer' }} onClick={() => window.location.href = '/dashboard'}>orrekie-platform</div>
        <div style={{ display: 'flex', gap: '2rem', alignItems: 'center' }}>
          {currentUser?.email && (
            <span style={{ color: '#fff', fontWeight: 500, fontSize: '1rem', marginRight: '1.5rem' }} title="Your email">{currentUser.email}</span>
          )}
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }} onClick={() => window.location.href = '/profile'}>
            <span style={{ color: '#fff', fontWeight: 500 }}>{currentUser?.displayName || 'User'}</span>
            <span style={{ fontSize: '1.3rem', color: '#ff4713' }} title="Profile & Settings">⚙️</span>
          </div>
          <button onClick={handleLogout} style={{ color: '#fff', background: 'none', border: 'none', fontWeight: 500, cursor: 'pointer' }}>Logout</button>
        </div>
      </nav>

      {/* Tabs */}
      <div style={{ maxWidth: 900, margin: '2rem auto', background: '#f9f9f9', borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.05)', padding: '2rem' }}>
        <div style={{ display: 'flex', borderBottom: '2px solid #eee', marginBottom: '2rem' }}>
          {tabs.map(tab => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              style={{
                background: 'none',
                border: 'none',
                borderBottom: activeTab === tab.key ? '3px solid #ff4713' : '3px solid transparent',
                color: activeTab === tab.key ? '#ff4713' : '#0a0e3f',
                fontWeight: activeTab === tab.key ? 700 : 500,
                fontSize: '1.1rem',
                padding: '1rem 2rem',
                cursor: 'pointer',
                outline: 'none',
                transition: 'border-bottom 0.2s, color 0.2s',
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div>
          {activeTab === 'bsa' && (
            <BSAQuery />
          )}
          {activeTab === 'uvalue' && (
            <div>
              <h2 style={{ color: '#0a0e3f', fontWeight: 700, fontSize: '1.5rem' }}>U Value Tool Calculator</h2>
              <p style={{ color: '#333' }}>This is a placeholder for the U Value Tool Calculator.</p>
            </div>
          )}
          {activeTab === 'regulations' && (
            <div>
              <h2 style={{ color: '#0a0e3f', fontWeight: 700, fontSize: '1.5rem' }}>Building Regulations Compliance Tool</h2>
              <p style={{ color: '#333' }}>This is a placeholder for the Building Regulations Compliance Tool.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
} 